import { render, staticRenderFns } from "./ConferenciaListPendentes.vue?vue&type=template&id=28a84689"
import script from "./ConferenciaListPendentes.vue?vue&type=script&lang=js"
export * from "./ConferenciaListPendentes.vue?vue&type=script&lang=js"
import style0 from "./ConferenciaListPendentes.vue?vue&type=style&index=0&id=28a84689&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports